// @flow

import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import type { Pet } from '@rover/react-lib/types';
import { getPetDetailsFromPet } from '@rover/react-lib/utils/pets';
import { CareInstructionsConstants } from '@rover/shared/js/constants/translation';

import SectionTitle from '../common/SectionTitle';

import CareInstruction from './CareInstruction';

type Props = {
  pets: Array<Pet>,
  isCareComplete: (url: string, field: string) => boolean,
};

const SectionWrapper: StyledComponent<{}> = styled.div`
  margin-left: 45px;
  margin-right: 45px;
`;

const CareInstructions = ({ pets, isCareComplete }: Props): Node => {
  const isFormComplete = pets.every(pet => isCareComplete(pet.url, 'careInstructions'));

  return (
    <SectionWrapper>
      <SectionTitle isComplete={isFormComplete} titleText={CareInstructionsConstants.title} />
      {pets.map(pet => (
        <CareInstruction
          key={pet.url}
          pet={pet}
          hasMultiplePets={pets.length > 1}
          value={pet.careInstructions}
          petDetails={getPetDetailsFromPet(pet)}
        />
      ))}
    </SectionWrapper>
  );
};

export default CareInstructions;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/CareInstructions/CareInstructions.jsx